import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from '../../../../shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from '../../../../shared/hooks/use-api-wrapper-with-error-validation/types'
import useUser from 'shared/hooks/use-user'
import { ManageSubscriptionsApiInterface } from '../types/manage-subscriptions-interface'
import { SwrPaginationInterface } from '../types/swr-pagination-interface'

export const MANAGE_SUBSCRIPTIONS_API = '/api/settings/customer-subscriptions'

interface UseManageSubscriptionsInterface extends SwrPaginationInterface {}

export function useManageSubscriptions({ limit, pagination }: UseManageSubscriptionsInterface) {
  const { user } = useUser()

  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    ManageSubscriptionsApiInterface
  >({
    method: RequestMethodsEnum.get,
  })

  return useSWR(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${MANAGE_SUBSCRIPTIONS_API}/list?pagination[limit]=${limit}`
    } else if (user && pagination.startFromId && limit) {
      return `${MANAGE_SUBSCRIPTIONS_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`
    }
  }, fetcher)
}
